import { useLocalHistory } from 'lib/useLocalHistory';
import { BaseRouteParams, ROUTES } from 'pages/routes';
import React from 'react';
import { useParams } from 'react-router';
import { useRouteScenario } from 'src/hooks/useRouteScenario';
import { OrderScenario } from '../model/Order';

const getConfirmAgeSessionStorageKey = (merchantId: string) => `a-v-${merchantId}`;
export const getConfirmAgeSessionData = (merchantId: string) =>
    sessionStorage.getItem(getConfirmAgeSessionStorageKey(merchantId));
export const setConfirmAgeSessionData = (merchantId: string, scenario: string) =>
    sessionStorage.setItem(getConfirmAgeSessionStorageKey(merchantId), scenario);

export function useConfirmAgeDialog() {
    const [scenario] = useRouteScenario();
    const { merchantId } = useParams<BaseRouteParams>();
    const [shouldCheckAgeVerification, setShouldCheckAgeVerification] = React.useState(
        !!merchantId &&
            getConfirmAgeSessionData(merchantId) !== scenario &&
            (scenario === OrderScenario.ORDER_TO_TABLE || scenario === OrderScenario.TABLE)
    );
    const { push } = useLocalHistory();
    const handleAgeVerificationConfirm = React.useCallback(() => {
        if (merchantId && scenario) {
            setConfirmAgeSessionData(merchantId, scenario);
        }
        setShouldCheckAgeVerification(false);
    }, [merchantId, scenario]);
    const handleAgeVerificationCancel = React.useCallback(() => {
        push(ROUTES.JOURNEY.LANDING);
        setShouldCheckAgeVerification(false);
    }, [push]);
    React.useEffect(() => {
        if (
            merchantId &&
            getConfirmAgeSessionData(merchantId) !== scenario &&
            (scenario === OrderScenario.ORDER_TO_TABLE || scenario === OrderScenario.TABLE)
        ) {
            setShouldCheckAgeVerification(true);
        }
    }, [merchantId, scenario]);
    return {
        open: shouldCheckAgeVerification,
        handleAgeVerificationConfirm,
        handleAgeVerificationCancel
    };
}
